/**
 * Sidebar/hooks/useSidebarCollapsed/index.ts
 * desc: collapsed state of the sidebar — the user's persisted choice
 * note: the sidebar never force-collapses by viewport width; the state lives in JS so the collapsed flyouts can
 *       follow it
 */

import { useCallback } from 'react';
import { useLocalStorage } from 'usehooks-ts';

export const COLLAPSED_STORAGE_KEY = 'navCollapsed';

const useSidebarCollapsed = () => {
    const [ isCollapsed, setIsCollapsed ] = useLocalStorage(COLLAPSED_STORAGE_KEY, false);
    const toggle = useCallback(() => setIsCollapsed((current) => !current), [ setIsCollapsed ]);

    return { isCollapsed, toggle };
};

export default useSidebarCollapsed;
